const DEBUGGER_FORM = {
  topics: {
    id: 709,
    code: 'Topic',
  },
  pageTopics: {
    id: 710,
    code: 'PageTopic',
  },
}

export const DEBUGGER_CRUD_NEW = {
  topics: {
    key: 'topics',
    formId: DEBUGGER_FORM.topics.id,
    code: DEBUGGER_FORM.topics.code,
    defaultPaging: { page: 0, pageSize: 1000 },
  },
  pageTopics: {
    key: 'pageTopics',
    formId: DEBUGGER_FORM.pageTopics.id,
    code: DEBUGGER_FORM.pageTopics.code,
    defaultPaging: { page: 0, pageSize: 1000 },
  },
}

export const DEBUGGER_CRUD = {}
